export default "__VITE_ASSET__755b044c__"